"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ItemTicker = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ItemInfo = _interopRequireWildcard(require("./ItemInfo.style"));

var ItemTicker = _ItemInfo.StyledItemTicker;
exports.ItemTicker = ItemTicker;

var Item = function Item(_ref) {
  var name = _ref.name,
      picture = _ref.picture,
      info = _ref.info,
      style = _ref.style,
      className = _ref.className,
      size = _ref.size,
      hideInfo = _ref.hideInfo,
      extraInfo = _ref.extraInfo,
      mode = _ref.mode;
  return _react.default.createElement(_ItemInfo.default, {
    size: size,
    className: className,
    style: style
  }, picture && _react.default.createElement("img", {
    alt: name,
    src: picture
  }), _react.default.createElement("div", null, _react.default.createElement(_ItemInfo.NameLabelStyle, {
    size: size,
    mode: mode
  }, name, extraInfo), hideInfo || _react.default.createElement(_ItemInfo.StyledInfo, {
    size: size
  }, info)));
};

Item.propTypes = {
  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
  picture: _propTypes.default.string,
  info: _propTypes.default.string,
  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
  hideInfo: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  extraInfo: _propTypes.default.object,
  mode: _propTypes.default.oneOf(['light', 'dark'])
};
Item.defaultProps = {
  info: '',
  picture: '',
  size: 'large',
  hideInfo: false,
  className: '',
  style: {},
  extraInfo: null,
  mode: 'light'
};
Item.ItemTicker = ItemTicker;
var _default = Item;
exports.default = _default;